import { pickAppCopy, type SupportedLocale } from "@patient-watch/i18n";
import { useAppLocale } from "./LocaleContext";
import { messageHistoryCopyEn } from "@patient-watch/i18n/webapp/en-GB/messageHistoryCopy";
import { messageHistoryCopyDe } from "@patient-watch/i18n/webapp/de-DE/messageHistoryCopy";
import { messageHistoryCopyDa } from "@patient-watch/i18n/webapp/da-DK/messageHistoryCopy";
import { messageHistoryCopyEnUs } from "@patient-watch/i18n/webapp/en-US/messageHistoryCopy";
import { messageHistoryCopyFr } from "@patient-watch/i18n/webapp/fr-FR/messageHistoryCopy";
import { messageHistoryCopyIt } from "@patient-watch/i18n/webapp/it-IT/messageHistoryCopy";
import { messageHistoryCopyEs } from "@patient-watch/i18n/webapp/es-ES/messageHistoryCopy";

export interface MessageHistoryCopy {
    title: string;
    noMessages: string;
    viewMessages: string;
    to: string;
    from: string;
    subject: string;
    statusClicked: string;
    statusRead: string;
    statusReadAt: string;
    statusDelivered: string;
    statusSent: string;
    statusPending: string;
    channelEmail: string;
    channelSms: string;
    retentionNotice: string;
}

const messageHistoryCopy: Record<SupportedLocale, MessageHistoryCopy> = {
    "en-GB": messageHistoryCopyEn,
    "en-US": messageHistoryCopyEnUs,
    "de-DE": messageHistoryCopyDe,
    "da-DK": messageHistoryCopyDa,
    "fr-FR": messageHistoryCopyFr,
    "it-IT": messageHistoryCopyIt,
    "es-ES": messageHistoryCopyEs,
};

export function getMessageHistoryCopy(locale: SupportedLocale): MessageHistoryCopy {
    return pickAppCopy(messageHistoryCopy, locale);
}

export function useMessageHistoryCopy(): MessageHistoryCopy {
    const { locale } = useAppLocale();
    return getMessageHistoryCopy(locale);
}
